module.exports = __webpack_public_path__ + "img/qrcode-1773.5079ca36.png";